import React from 'react'
import { FooterDiv, ItensDiv, StyledButton } from './footer.styled.component'
import { Text } from '../../../'
import { useResize } from '../../../../hooks'
import  UNIQUE from '../../../../assets/icons/icon1.svg'
import  SUSTAINABLE  from '../../../../assets/icons/icon2.svg'
import  COMFORT  from '../../../../assets/icons/icon3.svg'

export const FooterComponent = ({ label_1, label_2, label_3, knowLLink, showKnowLink = true }) => {

  label_1 = 'Unique design'
  label_2 = 'Sustainble wallcovergins'
  label_3 = 'Extra comfort'

  const isMobile = useResize().isMobile;

  return (
    <>
      <FooterDiv>
        <ItensDiv>
          <img alt='icon-unique' src={UNIQUE}></img>
          <Text
            className="d-inline"
            fontFamily=""
            fontSize="16px"
            textId="product-detail.unique-design"
          />
        </ItensDiv>
        <ItensDiv>
          <img alt='icon-sustainable' src={SUSTAINABLE}></img>
          <Text
            className="d-inline"
            fontFamily=""
            fontSize="16px"
            textId="product-detail.sustainable"
          />
        </ItensDiv>
        <ItensDiv>
          <img alt='icon-comfort' src={COMFORT}></img>
          <Text
            className="d-inline"
            fontFamily=""
            fontSize="16px"
            textId="product-detail.extra-comfort"
          />
        </ItensDiv>
        {
          (!isMobile && showKnowLink === true) &&
          <StyledButton onClick={() => knowLLink()}>
            <Text
              fontFamily="Amorim Sans Book"
              fontSize="14px"
              textId="product-detail.know-more"
            />
          </StyledButton>
        }
      </FooterDiv>
    </>
  )
};
